import { FunctionComponent, useEffect, useState } from "react";

import { PageNotFound } from "./components/PageNotFound";

// Note that <PageNotFound> from @digital-services/shell is used instead of this component now
// In future remove this lister at all

export const PageNotFoundListener: FunctionComponent = () => {
  const [pageIsNotFound, setPageIsNotFound] = useState<boolean>(false);

  const checkForPageNotFound = () => {
    const el = document.getElementById("PAGE_NOT_FOUND");

    setPageIsNotFound(!!el);
  };

  useEffect(() => {
    const observer = new MutationObserver(checkForPageNotFound);
    observer.observe(document.body, { childList: true, subtree: true });

    globalThis.addEventListener(
      "single-spa:routing-event",
      checkForPageNotFound
    );

    checkForPageNotFound();

    return () => {
      observer.disconnect();
      globalThis.removeEventListener(
        "single-spa:routing-event",
        checkForPageNotFound
      );
    };
  }, []);

  return pageIsNotFound ? <PageNotFound /> : null;
};
